export const meta: BlockMeta = {
  title: "SquadUp Purchase",
  tags: ["subpage"],
}

import { GenericSquadupTicketWidget } from "@components/film/GenericSquadupTicketWidget"
import { defineBlock, EditableText, useInlineEditableValue } from "eddev/blocks"

export default defineBlock("tickets/squadup-purchase", (props) => {
  const description = useInlineEditableValue<string>("description")

  return (
    <div className="my-3">
      <GenericSquadupTicketWidget
        heading={<EditableText store="heading" placeholder="Enter an optional heading" />}
        description={
          !env.admin ? description[0] : <EditableText store={description} placeholder="Enter an optional description" />
        }
        bookLabel={
          <span
            onClick={(e) => {
              if (env.admin) e.stopPropagation()
            }}
          >
            <EditableText store="bookLabel" defaultValue="Book now" />
          </span>
        }
        enabled={!!props.enabled}
        squadupEventId={props.squadupId!}
        squadupOptions={{
          shoppingCartEnabled: props.enableShoppingCart ? true : false,
        }}
      />
    </div>
  )
})
